import { render, staticRenderFns } from "./BlockType110.vue?vue&type=template&id=1bc2d100&scoped=true"
import script from "./BlockType110.vue?vue&type=script&lang=ts"
export * from "./BlockType110.vue?vue&type=script&lang=ts"
import style0 from "./BlockType110.vue?vue&type=style&index=0&id=1bc2d100&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc2d100",
  null
  
)

export default component.exports